import React, { useState, useEffect } from 'react';
import './AboutInfo.css';

function AboutInfoBlock() {
  const highlights = [
    {
      title: 'Diverse Genres',
      description: 'From indie to hip hop, electronic to DJ sets, we curate music for every soul.',
    },
    {
      title: 'Nationwide Reach',
      description: 'Events from Cape Town to Johannesburg, uniting South Africa through music.',
    },
    {
      title: 'Unforgettable Experiences',
      description: 'Immersive atmospheres where every note resonates and every moment shines.',
    },
  ];

  const [currentHighlight, setCurrentHighlight] = useState(0);

  // Auto-rotate highlights every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHighlight((prev) => (prev + 1) % highlights.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [highlights.length]);

  const handleHighlightClick = (index) => {
    setCurrentHighlight(index);
  };

  return (
    <section className="about-section" aria-labelledby="about-title">
      <h1 id="about-title" className="about-title">
        About CRP NOCTEM
      </h1>
      <div className="about-content">
        <p className="about-info">
          At CRP NOCTEM, we ignite South Africa with the pulse of live music. We specialize in a vibrant spectrum of genres—sultry indie, electrifying hip hop, dystopian electronic beats, and the dynamic spins of South Africa’s top DJs. Our events are crafted to deliver unforgettable experiences for every music lover.
          <br /><br />
          With deep expertise and a passion for live entertainment, we produce high-quality events tailored to diverse tastes. From corporate gatherings to massive festivals and intimate venues, we bring world-class local and international talent to stages nationwide.
          <br /><br />
          From the iconic waterfronts of Cape Town to the bustling streets of Johannesburg, our performances unite communities through the power of sound. We create immersive worlds where every beat vibrates and every moment is a celebration.
          <br /><br />
          Join us to experience the magic of live music as we redefine connection and sound across South Africa.
        </p>
        <div className="highlights-carousel">
          <div className="highlight-item" role="tabpanel" aria-labelledby={`highlight-${currentHighlight}`}>
            <h2 className="highlight-title">{highlights[currentHighlight].title}</h2>
            <p className="highlight-description">{highlights[currentHighlight].description}</p>
          </div>
          <div className="highlight-nav" role="tablist">
            {highlights.map((_, index) => (
              <button
                key={index}
                className={`highlight-nav-item ${index === currentHighlight ? 'active' : ''}`}
                onClick={() => handleHighlightClick(index)}
                aria-selected={index === currentHighlight}
                role="tab"
                id={`highlight-nav-${index}`}
                aria-controls={`highlight-${index}`}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </div>
        {/* <a
          href="https://nocturnalforever.com"
          target="_blank"
          rel="noopener noreferrer"
          className="learn-more-button"
          aria-label="Learn more about CRP NOCTEM"
        >
          Learn More
        </a> */}
      </div>
    </section>
  );
}

export default AboutInfoBlock;